import type { ReactElement } from "react";
import { useRef } from "react";

import { CSSTransition } from "react-transition-group";
import type { CSSTransitionProps } from "react-transition-group/CSSTransition";

import { COLUMN_ROW_TRANSITION_MS } from "app/pages/sales-intelligence/common-components/column-picker/constants";

import { VirtualFadeContainer } from "./styles";

type NotSelectedColumnOptionFadeTransitionProps = Omit<CSSTransitionProps, "addEndListener"> & {
    children: ReactElement;
};

/**
 * The virtualised counterpart of {@link ColumnOptionFadeTransition}. Same animation, but the row is
 * positioned out of flow — the caller supplies its offset through `style`, which `Transition`
 * forwards onto the container. Never pass `height` that way: an inline height would beat the
 * `.fade-exit-active` class rule and silently kill the collapse.
 */
export const NotSelectedColumnOptionFadeTransition = (props: NotSelectedColumnOptionFadeTransitionProps) => {
    const nodeRef = useRef(null);

    return (
        <CSSTransition
            timeout={COLUMN_ROW_TRANSITION_MS}
            classNames="fade"
            {...props}
            nodeRef={nodeRef}
        >
            <VirtualFadeContainer ref={nodeRef}>{props.children}</VirtualFadeContainer>
        </CSSTransition>
    );
};
